import { TreeSelect } from 'antd';
import type { TreeSelectProps } from 'antd';
import type { ReactElement } from 'react';
import { AntTreeSelect } from './styles/treeSelect.style';
import type { SelectStyleProps } from './styles/select.style';

type CompoundTreeSelect = typeof TreeSelect &
  ((props: TreeSelectProps & SelectStyleProps) => ReactElement);

const StyledAntTreeSelect = AntTreeSelect(TreeSelect) as unknown as CompoundTreeSelect;

export default StyledAntTreeSelect;
